module.exports = __webpack_public_path__ + "img/1aba77b.jpg";